
import Vue from 'vue';
import { useSupportWidget } from '@/composables/useSupportWidget';

const { syncSupportWidgetLanguage } = useSupportWidget();

export default Vue.extend({
    name: 'App',
    watch: {
        // The widget is loaded in public/index.html and cannot switch language on its own,
        // so reload it whenever the user changes the app language.
        '$i18n.locale': function (locale: string) {
            syncSupportWidgetLanguage(locale);
        },
    },
    metaInfo() {
        const href = new URL(this.$route.fullPath, ENV.BASE_URL).href;
        return { link: [{ rel: 'canonical', href }] };
    },
});
